import { Button, Dropdown,message, Modal, Spin, Collapse } from 'antd';
import React, { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { getCoursesList, updateCourse, useGetCourseAttendancesFilter,deleteStudentFromCourse} from '../../../api/courses';
import {updateFile} from '../../../api/files';
import { useGetStudent} from '../../../api/students';
import { QueryParams } from '../../../interfaces';
import { Attendances } from '../../../interfaces/attendances';
import { ClassWorks } from '../../../interfaces/classWorks';
import { getCoachesList } from '../../../api/coaches';
import { DATE_FORMAT_FRONTEND, PAGE_SIZE } from '../../../shared/constants';
import DangerButton from '../../../shared/components/buttons/DangerButton';
import ClassWorksCardUpdate from '../../../shared/components/cardViews/ClassWorks/ClassWorksUpdate';
import { Link } from 'react-router-dom';
import {createClassWorks} from '../../../api/classWorks';
const { Panel } = Collapse;
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import CourseStudentsAddClassWorks from '../../../shared/components/modal/CourseStudentsAddClassWorks';
import { useUrlFilter } from "react-filter-by-url";
import SecondaryButton from '../../../shared/components/buttons/SecondaryButton';
import AddCircleOutlineIcon from '../../../shared/svgs/AddCircleOutlineIcon';

dayjs.extend(customParseFormat);
import moment from 'moment';
import { StudentAttendances } from '../../../interfaces/studentAttendances';
import { File } from '../../../interfaces/file';
const ClassWorksCourseClassWorksUpdatePage: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { id } = useParams<{ id: string }>();
  const params = new URLSearchParams(window.location.search);
  const studentId = params.get('studentId')
  const [queryParams, setQueryParams] = useState<QueryParams>({ start: 0, count: PAGE_SIZE,filter:{courseId:Number(id),studentId:Number(studentId)} });
  const { data:courseAttendances, isLoading }= useQuery(['coaches', 'list', queryParams], () => useGetCourseAttendancesFilter(Number(id),queryParams));
  const { data: student, isLoading:isStudentLoading } = useGetStudent(Number(studentId));

  const currentPage = queryParams.start ? Math.round((Number(queryParams.start) - 1) / PAGE_SIZE + 1) : 1;
  const pagination: any = {
    current: currentPage,
    pageSize: PAGE_SIZE,
    total: courseAttendances?.attendances?.studentAttendances?.total || 0,
    showTotal: (total: string) => `${total} Items`,
  };
  const { mutateAsync: mutationAddClassWorks} = useMutation(createClassWorks);
  const [ isEmergencyContactModalVisible , setIsEmergencyContactModalVisible] = useState<boolean>(false);
  const [modalData, setModalData] = useState(null);
  let [openPanels, setOpenPanels] = React.useState<any>([]);
  const onEmergencyContactCancel = () => {
    setIsEmergencyContactModalVisible(false);
  };

  const onEditClick = (modalData:any) =>   {
    setIsEmergencyContactModalVisible(true);
    setModalData(modalData)
  };

  const onChange = (key: string | string[],modalData:any) => {
    const newKey = [key[key.length-1]]
    setOpenPanels([]) //close all
    setOpenPanels(newKey) //open selected
    if(key.length>0){
      setModalData(modalData)
    }
  };
 
  const { mutateAsync: updateMutate } = useMutation(updateCourse, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['courses', 'list'],
      });
      queryClient.invalidateQueries({
        queryKey: [`courses/${id}`, undefined],
      });
      message.info('Update course successfully!');
      navigate(`/admin/courses`);
    },
    onError: () => {
      message.error('Update course failed! Please try again');
    },
    onSettled: () => {
      queryClient.prefetchQuery({
        queryKey: ['courses', 'list', { start: 0, count: PAGE_SIZE, filter: undefined }],
        queryFn: () => getCoursesList({ start: 0, count: PAGE_SIZE, filter: undefined }),
      });
    },
  });

  // const { mutateAsync: mutationUpdate } = useMutation(deleteStudentFromCourse);
  const handleCancel = () => {
    setIsEmergencyContactModalVisible(false);
  };

  const handleClickDelete = async (courseId : number , studentId : number) => {
    await deleteStudentFromCourse(courseId,studentId);
    queryClient.invalidateQueries({
      queryKey: ['students', 'list'],
    });
  };

  const handleSubmit = async (values: any) => {
    updateFile({ id: values.fileId, ...values});
    updateMutate({ ...values, id });
  };

  const handleAddClassWorks = async (values: any) => {
    await mutationAddClassWorks({ id: values.fileId, body: values});
    queryClient.invalidateQueries({
      queryKey: [`file/${values.fileId}`, undefined],
    });
  };

  const withAction = (record: any) => {
    return (
      <span className="action" style={{ display: 'flex' }}>
        <Dropdown.Button
          overlayClassName="table-action-menu"
          menu={{
            items: [
              {
                key: '1',
                label: (
                  <Link to={`/admin/users/${record?.id}`}>
                    <Button className="btn-table-action-primary" type="link">
                      View
                    </Button>
                  </Link>
                ),
              },
              {
                key: '4',
                label: <DangerButton label="Delete" onOk={() => handleClickDelete(Number(id),Number(record?.id))} />,
              },
            ],
          }}
        ></Dropdown.Button>
      </span>
    );
  };

  return (
        <Spin spinning={isStudentLoading}>
      <div id="user-details-container">
        <div className="page-container">
          <div className="page-content">
            <div className="page-content-header">
              <h2 className="title-page" style={{fontSize:'26px'}}>Student Details</h2>
            </div>
            <div className="details-container">
              <div className="item">
                <label>Student Name</label>
                <span className="value">{student?.firstName} {student?.lastName}</span>
              </div>
              <div className="item">
                <label>contact</label>
                <span className="value">
                  {student?.contact}
                </span>
              </div>
              <div className="item">
                <label>email</label>
                <span className="value">
                  {student?.email} 
                </span>
              </div>
            </div>
          </div>
          <div className="page-content">
            <div className="page-content-header">
              <h2 className="title-page" style={{fontSize:'26px'}}>Class Works</h2>
            </div>
            <div className="details-container">
              <div className="item">
                <label>Course Name</label>
                <span className="value">{courseAttendances?.name}</span>
              </div>
              <div className="item">
                <label>Start At</label>
                <span className="value">
                  {courseAttendances?.startAt}
                </span>
              </div>
              <div className="item">
                <label>End At</label>
                <span className="value">
                  {courseAttendances?.endAt} 
                </span>
              </div>
            </div>
          </div>
          {courseAttendances?.attendances?.map((attendance: Attendances) => (
          <><Collapse activeKey={openPanels}  style={{color:'#939ca3 !important'  ,backgroundColor:'#23395d', alignItems:'self-end',fontSize:'large', borderRadius: '36px'}} expandIconPosition="end" onChange={e => onChange(e, {'studentId':Number(studentId),'attendancesId':Number(attendance.id),'courseId':Number(id)})}>
              <Panel header={attendance.location + ' <'+ dayjs(attendance.date).format(DATE_FORMAT_FRONTEND) + '-' +attendance.startAt+ '-' + attendance.endAt + '>'} key={attendance.id} className="collapse-custom-header" >
                      <div className='ant-collapse-content-box'>
                      <ClassWorksCardUpdate    
                          classWorkInfo={modalData}                   
                          />
                        </div>
              </Panel>
            </Collapse><div style={{paddingTop:'10px'}}></div></>
           ))}
        </div>
      </div>
    </Spin>
  );
};

export default ClassWorksCourseClassWorksUpdatePage;
